<template>
    <div class="new-request__footer">
        <!-- <app-select  :value="getResponsibleUser" :items="getUsers" :upIcon="true" :downIcon="false" style="padding: 0 10px; width: 180px;" :popoverProps="{verticalOffset: 0, horizontalOffset: -15, placement: 'bottom-start'}"
                     @input="VXORM.Request.updateModelValue(VXORM.Request, 'responsibleUserId', request.id, $event)">
            <input type="text" class="select readonly" style="height: 40px; margin: 0; padding: 0; border: none;" readonly :value="getResponsibleUser" />
            <template slot="item" slot-scope="slotProps">
                <span>{{ slotProps.text }}</span>
            </template>
        </app-select> -->
        <div class="menu-rf" ref="contentMenu">
            <div v-show="isActiveMenu" class="box-status-rf">
                <app-perfect-scrollbar class="column-box-status-rf" >
                    <div>
                        <ul>
                            <li v-for="user of getUsers" :key="user.value"
                                :class="{ 'selected-status': request.responsibleUserId == user.value }" 
                                @click="selectUser(user)"
                                style="display: flex; align-items: center;" 
                            >
                                <icon-card-flag v-show="request.responsibleUserId == user.value" class="flag-icon-menu"></icon-card-flag>
                                <div v-if="user.available && user.defaultCompanyId === company.id" class="available-icon"></div>
                                {{ utils.toTitleizeString(user.text) }}
                            </li>
                        </ul>
                    </div>
                </app-perfect-scrollbar>
                <app-perfect-scrollbar class="column-box-status-rf">
                    <div>
                        <ul>
                            <li v-for="(status, index) of requestStatus" :key="index" 
                                :class="{ 'selected-status': status.isSelected }"
                                @click="selectStatus(status.type)">
                                <icon-status-selection v-show="status.isSelected" class="flag-icon-menu"></icon-status-selection>
                                {{ status.name }}
                            </li>
                        </ul>
                    </div>
                </app-perfect-scrollbar>
            </div>
            <div class="label-box-status-rf" @click="isActiveMenu = !isActiveMenu">
                <div style="display: flex;" :class="{ 'active-menu': isActiveMenu }">
                    <div style="position: relative; right: 5px;">
                        <fa icon="flag" size="sm" />
                    </div>
                    {{ !request.zepplinId ? utils.getShortString(utils.toTitleizeString(getResponsibleUser), 15, '...') : utils.toTitleizeString(getResponsibleUser) }}
                    <div style="display: flex;">
                        <div class="dot"></div>
                        <div>{{ getStatusSelected.name }}</div>
                    </div>
                    <div style="margin-left: 8px;">
                        <fa icon="chevron-up" size="sm"/>
                    </div>
                </div>
            </div>
            
        </div>
        <span style="flex-grow: 1"></span>
        <div style="display: flex; align-items: center">
            <div v-if="!request.zepplinId" style="background: rgba(115, 119, 123, 0.123); height: 40px;">
                <div v-if="activeTab === 'contact'" @click="saveContact()" 
                    class="secondary-burron-rf">
                    <!-- <icon-request-status class="new-footer__img"></icon-request-status> -->
                    <span class="new-footer__text">{{ utils.isTmp(request.requestContact.contactId) ? 'Salvar' : 'Atualizar' }} contato</span>
                </div>

                <div v-if="activeTab === 'order'" @click="submitOrderAndAssociate()" class="secondary-burron-rf">
                    <!-- <icon-request-status class="new-footer__img"></icon-request-status> -->
                    <span class="new-footer__text">{{ utils.isTmp(request.id) ? 'Salvar' : 'Atualizar' }} pedido sem contato</span>
                </div>
            </div>
            <a v-if="!request.zepplinId || (request.STATE_request.persistedStatus != request.status && request.responsibleUserId)" class="new-request__button background-button" href="javascript:void(0)" @click="submit()">
                <icon-request-send class="img"></icon-request-send><span class="new-request__span">{{ utils.isTmp(request.id) ? 'Enviar' : 'Atualizar' }}</span>
            </a>
        </div>
    </div>
</template>

<script>
import ContactAPI from '../../../../../api/contacts'
import RequestAPI from '../../../../../api/requests'
import moment from 'moment'
import shortid from 'shortid'
import { mapActions, mapState } from 'vuex';
import { point } from '@turf/turf'
import distance from '@turf/distance'
import _ from 'lodash'

export default {
    props:['activeTab', 'request'],
    data() {
        return {
            isActiveMenu: false,
            leaveTimeout: null,
        }
    },
    computed: {
        ...mapState("request-board", ["filters"]),
        ...mapState('auth', ['company']),
        getUsers() {
            if(this.request && this.request.requestContact && this.request.requestContact && 
                Number.isInteger(this.request.requestContact.contactAddressId) && 
                (_.result(this.request,'requestContact.contactAddress.lat',false) && _.result(this.request,'requestContact.contactAddress.lng',false))) {

                let devices = this.VXORM.Device.query()
                    .with('user')
                    .with('locations')
                    .where('status', 'active')
                    .get()
    
                devices = devices
                    .map(device => {
                        if(device.locations.length && device.available && device.user.defaultCompanyId === this.company.id){
                            device.locations = _.sortBy(device.locations,(location) => {
                                return -location.id
                            })
    
                            device.lastLocation = device.locations[0]
                            return device
                        } 
                    })
                    .filter(device => device)

                let lngLat = [this.request.requestContact.contactAddress.lng, this.request.requestContact.contactAddress.lat]
                const _company = _.get(this.request.STATE_request, 'card.company', null)
                if(_company && _company.lngLat && _company.id != this.company.id)
                    lngLat = _company.lngLat
                    
                devices = _.orderBy(devices, device => {
                    const from = point([device.lastLocation.lng, device.lastLocation.lat])
                    const to = point(lngLat)
                    const distanceBetweenInKm = distance(from, to, {units: 'kilometers'})
                    return distanceBetweenInKm
                })

                let users = _.sortBy(
                    this.VXORM.CompanyUser.query()
                        .with('user')
                        .where(companyUser => 
                            (companyUser.status === 'active' 
                                && !!this.VXORM.CompanyUserResource.query()
                                        .where(companyUserResource => 
                                            companyUserResource.operation === 'visible-as-responsible' && companyUser.id == companyUserResource.companyUserId)
                                        .first())
                                || companyUser.user && companyUser.user.isMaster)
                        .get()
                        .filter(companyUser => companyUser.user.status == 'active')
                        .map(companyUser => {
                            return { id: companyUser.user.id, name: companyUser.user.name, defaultCompanyId: companyUser.user.defaultCompanyId }
                        }),
                    companyUserMapped => 
                        companyUserMapped.name)

                let usersWithDevices = devices.map(device => {
                    return { id: device.user.id, name: device.user.name, available: device.available, defaultCompanyId: device.user.defaultCompanyId }
                })

                users.unshift(usersWithDevices)
                users = _.intersectionBy(_.flatten(users), 'id')
    
                return users.map(user => {
                    return { 
                        value: user.id, 
                        text: user.name,
                        available: user.available,
                        defaultCompanyId: user.defaultCompanyId
                    }
                })
            } else {
                let companyUsers = _.sortBy(
                    this.VXORM.CompanyUser.query()
                        .with('user')
                        .with('user.devices')
                        .where(companyUser => 
                            companyUser.status === 'active'
                                && !!this.VXORM.CompanyUserResource.query()
                                    .where(companyUserResource => 
                                        companyUserResource.operation === 'visible-as-responsible' 
                                            && companyUser.id == companyUserResource.companyUserId)
                                    .first())
                        .get(), 
                    companyUser => {
                        return companyUser.user.name
                    })

                companyUsers = companyUsers.filter(companyUser => companyUser.user.status == 'active').map(companyUser => {
                    return { 
                        value: companyUser.user.id, 
                        text: companyUser.user.name,
                        available: companyUser.user.devices.length && companyUser.user.devices[0].available ? companyUser.user.devices[0].available : null,
                        defaultCompanyId: companyUser.user.defaultCompanyId
                    }
                })

                return _.sortBy(companyUsers, 
                    companyUser => companyUser.available && companyUser.defaultCompanyId === this.company.id)
            }
        },
        getResponsibleUser() {
            return Number.isInteger(this.request.responsibleUserId) ? this.VXORM.User.query().where('id', this.request.responsibleUserId).first().name : 'Sem usuário'
        },
        getStatusSelected() {
            let selectedStatus = {} 
            this.requestStatus.forEach(status => {
                if(this.request.status === status.type) selectedStatus = status
            })
            return selectedStatus
        },

        requestStatus() {
            let requestStatus = [
                { name: 'pendente', type: 'pending', isSelected: false },
                { name: 'em preparo', type: 'in-provision', isSelected: false },
                { name: 'enviado', type: 'sent', isSelected: false },
                { name: 'em progresso', type: 'in-displacement', isSelected: false },
                { name: 'finalizado', type: 'finished', isSelected: false },
                { name: 'cancelado', type: 'canceled', isSelected: false },
                { name: 'removido', type: 'removed', isSelected: false },
            ]
            if(this.request.zepplinId) {
                return requestStatus.map(status => {
                    const persistedStatus = this.request.STATE_request.persistedStatus
                    if(this.request.status === status.type) status.isSelected = true
                    if(status.type === 'removed' && persistedStatus !== 'removed') return
                    else if(persistedStatus === 'pending'
                        && (status.type !== 'pending'
                            && status.type !== 'in-provision'
                            && status.type !== 'canceled')) return
                    else if(persistedStatus === 'in-provision' 
                        && (status.type !== 'in-provision' 
                            && status.type !== 'sent')
                            && status.type !== 'canceled') return
                    else if(persistedStatus === 'sent' 
                        && (status.type !== 'sent' 
                            && status.type !== 'in-displacement'
                            && status.type !== 'canceled')) return
                    else if(persistedStatus === 'in-displacement' 
                        && (status.type !== 'finished' 
                            && status.type !== 'in-displacement'
                            && status.type !== 'canceled')) return
                    else if(persistedStatus === 'finished' && status.type !== 'finished') return
                    else if(persistedStatus === 'canceled' && status.type !== 'canceled') return
                    return status
                }).filter(status => status)
            }
            else {
                return requestStatus.map(status => {
                    if(status.type === 'in-provision') return
                    if(this.request.status === status.type) status.isSelected = true
                    return status
                }).filter(status => status)
            }
        },

        isCallerId() {
            return this.VXORM.CompanySetting.query().where(companySetting => (companySetting.key === 'isCallerId' && companySetting.value === 'true')).first()
        }
    },
    methods: {
        ...mapActions("toast", ["showToast", "showError"]),

        async submit(){
            let hasError = false
            if(!this.request.zepplinId) {
                const validations = this.validatorContactFields(this.request)
                validations.forEach(validation => {
                    hasError = true
                    this.showError(validation.message)
                })
                const validationsRequestContact = this.validatorRequestContactFields(this.request)
                validationsRequestContact.forEach(validation => {
                    hasError = true
                    this.showError(validation.message)
                })
                const validationsRequestOrder = this.validatorRequestOrderFields(this.request)
                await validationsRequestOrder.forEach(validation => {
                    hasError = true
                    this.showError(validation.message)
                })
                if(hasError) return
            }

            if(!this.request.zepplinId)
                try {
                    await this.saveContact(true)
                }
                catch(err) {
                    console.log(err)
                    this.showError('Algo deu errado.')
                    return Promise.reject(err)
                }

            this.request.STATE_request.$update({
                where: this.request.STATE_request.id,
                data: {
                    loading: {
                        show: true,
                        text: 'Salvando pedido...'
                    }
                }
            })

            const sendData = this.utils.removeTmpIds((this.request))
            _.assign(sendData, {
                STATE_request: null,
                STATE_requestId: null,
                finishedBy: sendData.status === 'finished' ? sendData.responsibleUserId : null
            })

            const requestOrderProducts = sendData.requestOrder.requestOrderProducts
                .map(requestOrderProduct => {
                    return requestOrderProduct.productId ? requestOrderProduct : null
                })
                .filter(requestOrderProduct => requestOrderProduct)

            const requestOrderServices = sendData.requestOrder.requestOrderServices
                .map(requestOrderService => {
                    return requestOrderService.serviceId ? requestOrderService : null
                })
                .filter(requestOrderService => requestOrderService)

            _.assign(sendData.requestOrder, {
                requestOrderProducts,
                requestOrderServices
            })

            const STATE_requestId = this.request.STATE_request.id
            let request
            try {
                if(!sendData.id)
                    request = await RequestAPI.createRequest(sendData).then(({data}) => data)
                else
                    request = await RequestAPI.updateRequest(sendData,sendData.id).then(({data}) => data)

                console.log(request)
            }
            catch(err) {
                console.log(err)
                if(this.request.zepplinId) {
                    const message = this.handleZepplinError(JSON.parse(err.body.message.slice(6, err.body.message.length)))
                    this.showError(message)
                }
                else {
                    this.showError('Algo deu errado.')
                }
                this.request.STATE_request.$update({
                    where: this.request.STATE_request.id,
                    data: {
                        loading: {
                            show: false,
                            text: null
                        }
                    }
                })
                return Promise.reject(err)
            }

            // verify if request order products is empty
            if(!request.requestOrder.requestOrderProducts.length)
                request.requestOrder.requestOrderProducts = [{
                    id: `tmp/${shortid.generate()}`,
                    requestOrderId: request.requestOrderId
                }]

            // verify if request order services is empty 
            if(!request.requestOrder.requestOrderServices.length)
                request.requestOrder.requestOrderServices = [{
                    id: `tmp/${shortid.generate()}`,
                    requestOrderId: request.requestOrderId
                }]
            
            this.request.deleteAllInRequest()
            this.VXORM.Request.insert({
                data: request,
                insertOrUpdate: [
                    'requestOrder',
                    'requestOrder.requestOrderProducts',
                    'requestOrder.requestOrderServices',
                    'requestOrder.requestOrderPayments',
                    'requestContact'
                ]
            })

            const requestDenormalized = this.VXORM.STATE_Request.denormalizeRequest(request, 'editing')
            this.VXORM.STATE_Request.update({
                where: STATE_requestId,
                data: {
                    requestCode: request.code,
                    requestId: request.id,
                    contactId: request.requestContact.contactId,
                    card: {
                        ...requestDenormalized.card
                    },
                    hasCard: true,
                    status: requestDenormalized.status,
                    persistedStatus: requestDenormalized.persistedStatus,
                    requestDateCreated: requestDenormalized.requestDateCreated,
                    loading: {
                        show: false,
                        text: null
                    },
                    responsibleUserIdPersisted: requestDenormalized.responsibleUserIdPersisted,
                }
            })

            this.showToast({
                message: 'Pedido salvo com sucesso!'
            })

            this.$bus.$emit(`STATE_request-${this.request.STATE_request.id}`, { success: true, STATE_request: requestDenormalized })
            this.$bus.$emit(`saveRequest`, { success: true, STATE_request: requestDenormalized })
            // if(this.utils.isTmp(this.request.id) || (this.request.status != 'pending' && this.request.status != 'in-displacement' && this.request.status != 'sent')) 
            //     await this.$nextTick(() => this.request.STATE_request.closeWindow())
            if(this.utils.isTmp(this.request.id)) {
                await this.$nextTick(() => {
                    this.request.STATE_request.$update({
                        where: this.request.STATE_request.id,
                        data: {
                            window: {
                                ...this.request.STATE_request.window,
                                show: false
                            },
                            card: {
                                ...requestDenormalized.card,
                                cardStatus: 'pending'
                            }
                        }
                    })
                    this.request.deleteAllInRequest()
                })
            }
            if((request.status != 'pending' && request.status != 'in-provision' && request.status != 'in-displacement' && request.status != 'sent') || 
                (request.isScheduled && moment(request.deliveryDate).local().format('DD') != moment(this.filters.deliveryDate).format('DD'))) { 
                await this.$nextTick(() => {
                    this.request.deleteAllInRequest()
                    this.request.STATE_request.$delete(this.request.STATE_request.id)    
                })}

        },
        async saveContact(submitRequest = false) {
            const vm = this
            
            if(!submitRequest) {
                const validations = this.validatorContactFields(this.request)
                let hasError = false
                validations.forEach(validation => {
                    hasError = true
                    console.log(validation)
                    this.showError(validation.message)
                })
                if(hasError) return
            }

            // set loading
            this.VXORM.STATE_Request.update({
                where: this.request.STATE_request.id,
                data: {
                    loading: {
                        show: true,
                        text: 'Salvando contato...'
                    }
                }
            })

            const sendData = this.utils.removeTmpIds(this.request.requestContact.contact)
            delete sendData.contactRequestContacts

            let contact
            try {
                if(!sendData.id){
                    contact = await ContactAPI.createContact(sendData).then(({data}) => data)
                }
                else {
                    contact = await ContactAPI.updateContact(sendData,sendData.id).then(({data}) => data)
                }
            } catch(err) {
                this.VXORM.STATE_Request.update({
                    where: this.request.STATE_request.id,
                    data: {
                        loading: {
                            show: false,
                            text: null
                        }
                    }
                })
                this.showError('Não foi possível salvar o contato.')
                return Promise.reject(err)
            }

            this.request.requestContact.contact.deleteAllInContact()

            this.VXORM.Contact.insert({
                data: contact,
                insertOrUpdate: [
                    'contactAddresses.address',
                    'contactPhones'
                ]
            })

            const contactAddressDefault = contact.contactAddresses.filter(contactAddress =>  contactAddress.isDefault )
            const contactPhoneDefault = contact.contactPhones.filter(contactPhone =>  contactPhone.isDefault )

            this.VXORM.RequestContact.update({
                where: this.request.requestContact.id,
                data: {
                    contactId: contact.id,
                    contactAddressId: contactAddressDefault[0] ? contactAddressDefault[0].id : null,
                    contactPhoneId: contactPhoneDefault[0] ? contactPhoneDefault[0].id : null
                }
            })

            let addressName = 
                `${contact.contactAddresses[0].address.name ? contact.contactAddresses[0].address.name : 'S/ Endereço'}, ` + 
                `${contact.contactAddresses[0].number ? contact.contactAddresses[0].number : 'S/ N' } $#! ` + 
                `${contact.contactAddresses[0].address.neighborhood ? contact.contactAddresses[0].address.neighborhood : 'S/ Bairro'}`

            const STATE_requests = this.VXORM.STATE_Request.query().where('contactId', contact.id).get()
            STATE_requests.forEach(async stateRequest => {
                await stateRequest.$update({
                    where: stateRequest.id,
                    data: {
                        card: {
                            ...stateRequest.card,
                            requestContactName: contact.name,
                            requestContactAddressName: addressName
                        },
                        loading: {
                            show: false,
                            text: null
                        }
                    }
                })
            })

            this.VXORM.STATE_Request.update({
                where: this.request.STATE_request.id,
                data: {
                    loading: {
                        show: false,
                        text: null
                    }
                }
            })

            this.showToast({
                message: 'Contato salvo com sucesso!'
            })
        },

        async submitOrderAndAssociate(submitAll = false) {
            const vm = this

            if(!this.utils.isTmp(this.request.requestContact.contactId)) {
                this.showError('Retire o contato do pedido para salvar ou atualizar um pedido sem contato.')
                return 
            }

            const validations = this.validatorRequestOrderFields(this.request)
            let hasError = false
            validations.forEach(validation => {
                hasError = true
                this.showError(validation.message)
            })
            if(hasError) return

            // set loading
            this.VXORM.STATE_Request.update({
                where: this.request.STATE_request.id,
                data: {
                    loading: {
                        show: true,
                        text: 'Enviando pedido sem contato...'
                    }
                }
            })

            let request = _.assign({}, this.utils.removeTmpIds(this.request), { 
                requestContact: null, 
                requestContactId: null, 
                status: (() => {
                    if(this.request.status === 'removed') return 'removed'
                    else if(this.request.status === 'canceled') return 'canceled'
                    else return 'finished'
                })(), 
                finishedBy: this.request.status === 'finished' ? this.request.responsibleUserId : null,
                STATE_request: null, STATE_requestId: null 
            })


            const requestOrderProducts = request.requestOrder.requestOrderProducts
                .map(requestOrderProduct => {
                    return requestOrderProduct.productId ? requestOrderProduct : null
                })
                .filter(requestOrderProduct => requestOrderProduct)

            const requestOrderServices = request.requestOrder.requestOrderServices
                .map(requestOrderService => {
                    return requestOrderService.serviceId ? requestOrderService : null
                })
                .filter(requestOrderService => requestOrderService)

            request.requestOrder = _.assign({}, request.requestOrder, {
                requestOrderProducts,
                requestOrderServices
            })

            try {
                if(!request.id) request = await RequestAPI.createRequest(request)
                else request = await RequestAPI.updateRequest(request, request.id)
            } 
            catch(err) {
                console.log(err)
                this.showError('Algo deu errado.')
                return
            } 
            finally {
                this.VXORM.STATE_Request.update({
                    where: this.request.STATE_request.id,
                    data: {
                        loading: {
                            show: false,
                            text: null
                        }
                    }
                })
            }

            await this.$nextTick(() => { 
                this.request.STATE_request.closeWindow(this) 
            })

            this.showToast({
                message: 'Pedido sem contato salvo com sucesso!'
            })

        },

        validatorRequestContactFields(request) {
            const vm = this
            let messages = []

            if(_.result(request,'requestContact.contact')) {
                if(_.isEmpty(request.requestContact.contact.name)) messages.push({ valid: false, message: 'Adicione um nome ao contato.' })

                if(_.result(request, 'requestContact.contact.contactAddresses') && _.every(request.requestContact.contact.contactAddresses, (contactAddress) => !contactAddress.isDefault)) {
                    messages.push({ valid: false, message: 'Selecione um endereço para entrega.' })
                }
                if(_.result(request, 'requestContact.contact.contactPhones') && _.every(request.requestContact.contact.contactPhones, (contactPhones) => !contactPhones.isDefault)) {
                    messages.push({ valid: false, message: 'Selecione um número de telefone.'})
                }
            }
            
            return messages
        },    

        validatorContactFields(request) {
            const vm = this
            let messages = []

            if(_.result(request,'requestContact.contact')) {
                const contact = request.requestContact.contact
                if(_.isEmpty(contact.name)) 
                    messages.push({ valid: false, message: 'Adicione um nome ao contato.' })
                if(_.result(contact, 'contactAddresses') && _.some(contact.contactAddresses, (contactAddress) => 
                    !contactAddress.number || !contactAddress.address.name || !contactAddress.address.neighborhood))
                    messages.push({ valid: false, message: 'Um endereço não pode ficar sem logradouro, número e bairro.' })
                if(_.result(contact, 'contactPhones') 
                    && _.some(contact.contactPhones, (contactPhone) => !contactPhone.number || contactPhone.number.length < 10))
                    messages.push({ valid: false, message: 'Adicione um número de telefone válido.'})

                const legalDocumentNumbers = contact.legalDocument && contact.legalDocument.replace(/[^\w\s]/gi, '').trim()
                if(legalDocumentNumbers) {
                    if(legalDocumentNumbers.length === 11 && !this.utils.validateCPF(legalDocumentNumbers))
                        messages.push({ valid: false, message: 'Adicione um CPF válido.' })
                    else if(legalDocumentNumbers.length === 14 && !this.utils.validateCNPJ(legalDocumentNumbers))
                        messages.push({ valid: false, message: 'Adicione um CNPJ válido.' })
                    else if(legalDocumentNumbers.length !== 11 && legalDocumentNumbers.length !== 14)
                        messages.push({ valid: false, message: 'Adicione um CPF ou CNPJ válido.' })
                }
            }
            
            return messages
        },

        validatorRequestOrderFields(request) {
            let messages = []

            if(!request.responsibleUserId)
                messages.push({ valid: false, message: 'Adicione um responsável ao pedido.' })
            
            if(request.zepplinId && !request.deliveryDate && (request.status === 'sent' || request.status === 'in-displacement'))
                messages.push({ valid: false, message: 'Você precisa definir a data de entrega.' })

            /* calculate requestOrderProducts */
            let requestOrderProducts = this.VXORM.RequestOrderProduct.query().where('requestOrderId', this.request.requestOrderId).get()
            requestOrderProducts = _.filter(requestOrderProducts,(requestOrderProduct) => {
                return requestOrderProduct.productId ? requestOrderProduct : null
            })
            let totalPriceProducts = this._.sumBy(
                requestOrderProducts, 
                (requestOrderProduct) => 
                    (requestOrderProduct.unitPrice - requestOrderProduct.unitDiscount) * requestOrderProduct.quantity)

            /* calculate requestOrderServices */
            let requestOrderServices = this.VXORM.RequestOrderService.query().where('requestOrderId', this.request.requestOrderId).get()
            requestOrderServices = _.filter(requestOrderServices,(requestOrderService) => {
                return requestOrderService.serviceId ? requestOrderService : null
            })
            const totalPriceServices = this._.sumBy(
                requestOrderServices, 
                (requestOrderService) => 
                    requestOrderService.price - requestOrderService.discount)

            let totalAmountPayments = this._.sumBy(
                this.VXORM.RequestOrderPayment.query().where('requestOrderId', this.request.requestOrderId).get(),
                requestOrderPayment => parseFloat(requestOrderPayment.amount))
                
            if(parseFloat(totalPriceProducts + totalPriceServices).toFixed(2) !== parseFloat(totalAmountPayments).toFixed(2)) {
                messages.push({ valid: false, message: 'O valor do pedido está diferente do valor de pagamento.' })
            }

            if(!request.phoneLineId && !request.zepplinId && this.isCallerId) {
                messages.push({ valid: false, message: 'Adicione uma linha telefônica.' })
            }
            if(_.some(request.requestOrder.requestOrderProducts, 
                (requestOrderProduct) => !Number.isInteger(requestOrderProduct.productId)) &&
                _.some(request.requestOrder.requestOrderServices, 
                (requestOrderService) => !Number.isInteger(requestOrderService.serviceId))
            ){
                messages.push({ valid: false, message: 'O pedido precisa ter um produto ou um serviço' })
            } else {
                let moreEqualProducts = false
                let products = request.requestOrder.requestOrderProducts
                for(let i = 0; i < products.length; i++) {
                    let equal = false
                    for(let col = 0; col < products.length; col++) {
                        if(products[i].productId === products[col].productId) {
                            if(equal) moreEqualProducts = true
                            equal = true
                        }
                        if(moreEqualProducts) break
                    }
                    if(moreEqualProducts) break
                }
                if(moreEqualProducts) {
                    messages.push({ valid: false, message: 'Os produtos não podem estar duplicados.' })
                }

                let moreEqualServices = false
                let services = request.requestOrder.requestOrderServices
                for(let i = 0; i < services.length; i++) {
                    let equal = false
                    for(let col = 0; col < services.length; col++) {
                        if(services[i].serviceId === services[col].serviceId) {
                            if(equal) moreEqualServices = true
                            equal = true
                        }
                        if(moreEqualServices) break
                    }
                    if(moreEqualServices) break
                }
                if(moreEqualServices) {
                    messages.push({ valid: false, message: 'Os serviços não podem estar duplicados.' })
                }
            }
            if(_.result(request,'requestOrder.requestOrderPayments') && _.some(request.requestOrder.requestOrderPayments,(requestOrderPayment) => !requestOrderPayment.paymentMethodId)){
                messages.push({ valid: false, message: 'Adicione as formas de pagamento corretamente.'})
            } else {
                let moreEqualPayments = false
                let payments = request.requestOrder.requestOrderPayments.filter(payment => !payment.paymentMethod.hasDeadline)
                for(let i = 0; i < payments.length; i++) {
                    let equal = false
                    for(let col = 0; col < payments.length; col++) {
                        if(payments[i].paymentMethodId === payments[col].paymentMethodId) {
                            if(equal) moreEqualPayments = true
                            equal = true
                        }
                        if(moreEqualPayments) break
                    }
                    if(moreEqualPayments) break
                }
                if(moreEqualPayments) {
                    messages.push({ valid: false, message: 'Os métodos de pagamento não podem estar duplicados.' })
                }
            }
            if(!request.requestOrder.promotionChannelId) messages.push({ valid: false, message: 'Você precisa selecionar o canal de divulgação.' })
            return messages
        },

        selectStatus(statusType) {
            this.request.$update({
                where: this.request.id,
                data: {
                    status: statusType
                }
            })
            this.requestStatus.map((status) => {
                statusType === status.type ? status.isSelected = true : status.isSelected = false    
                return status
            })
        },

        selectUser(user) {
            this.request.$update({
                where: this.request.id,
                data: {
                    responsibleUserId: user.value
                }
            })
        },

        onMouseLeave() {
            this.leaveTimeout = setTimeout(() => {
                this.isActiveMenu = false
            }, 1300);
        },

        onMouseOver() {
            clearTimeout(this.leaveTimeout)
        },

        onBodyClick(event) {
            if (this.$refs.contentMenu && (this.$refs.contentMenu !== event.target && !this.$refs.contentMenu.contains(event.target)) ) {
                this.isActiveMenu = false
            }
        },

        handleZepplinError(error) {
            switch(error.code) {
                case 117: return 'Pedido com status Pendente só pode ser alterado para Enviado ou Cancelado.'
                case 118: return 'Pedido com status Enviado só pode ser alterado para Em Progresso ou Cancelado.'
                default: return 'Algo deu errado.'
            }
        }
    },
    mounted() {
        document.addEventListener('mousedown', this.onBodyClick)
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this.onBodyClick)
    }
}
</script>

<style lang="scss">
    .new-request__footer {
        width: 100%;
        height: 40px;
        background-color: #23272B;
        display: flex;
        flex-direction: row;
        align-items: center;
        flex-shrink: 0;
        .new-footer__img{
            margin: 0px 10px;
        }
        .new-footer__text{
            font-size: 14px;
            color: #73777B;;
            font-family: Arial, Helvetica, sans-serif;
        }
    }
    .background-button{
        background: linear-gradient(89.54deg, #0072E4 -0.59%, #25A0A8 100.95%);
        span{
            color: white;
        }
    }

    .new-request__button{ 
        width: 100px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 0;
        background: linear-gradient(89.54deg, #0072E4 -0.59%, #25A0A8 100.95%);
        color:white;
        cursor: pointer;
    }
    .new-request__span{
        font-size:14px;
    }
    .new-request__button .img{
        margin-right: 5px;
        padding-top: 2px;
    }

    .menu-rf {
        display: flex;
        flex-direction: column;
    }

    .box-status-rf {
        width: 430px;
        height: 200px;
        position: absolute;
        bottom: 40px;
        display: flex;
        color: #73777B;
        max-height: 400px;
        z-index: 10;
    }

    .label-box-status-rf div:first-child{
        color: #73777B;
        font-weight: 600;
    }

    .label-box-status-rf {
        padding: 15px;
        display: flex;
        align-items: center;
        cursor: pointer;
    }

    .column-box-status-rf {
        max-height: 200px;
        background: #23272B;
        padding-right: 30px;
    }

    .column-box-status-rf div {
        padding-top: 20px;
    }

    .column-box-status-rf:last-of-type {
        background: #2A2E33;
    }

    .column-box-status-rf ul li{
        font-weight: 600;
        cursor: pointer;
        margin-bottom: 3px;
        width: 100%;
        padding-left: 55px;
    }

    .selected-status {
        color: #4D76C8;        
        display: flex;
        flex-direction: row;
        padding-left: 40px !important;
    }

    .active-menu, .active-menu div{
        color: #4D76C8 !important;
    }

    .flag-icon-menu {
        width: 15px;
        position: relative;
        right: 10px;
    }

    .secondary-burron-rf {
        margin-right: 20px; margin-left: 20px; height: 100%; cursor: pointer; display:flex; align-items: center;
    }

    .available-icon {
        width: 5px;
        height: 5px;
        margin-right: 10px;
        padding: 0 !important;
        border-radius: 100%;
        background: rgb(85, 233, 26);
    }

</style>
